/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createFileRevisionResponseFromDiscriminatorValue, createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, serializeCompleteUploadRequest, serializeFileRevisionResponse, type CompleteUploadRequest, type FileRevisionResponse, type HttpValidationProblemDetails, type IError } from '../../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/{file-id}/revisions/{revisionId}/upload/complete
 */
export interface CompleteRequestBuilder extends BaseRequestBuilder<CompleteRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FileRevisionResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     post(body: CompleteUploadRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FileRevisionResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CompleteUploadRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CompleteRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}/revisions/{revisionId}/upload/complete";
/**
 * Metadata for all the requests in the request builder.
 */
export const CompleteRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CompleteRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFileRevisionResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCompleteUploadRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
